import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.625 14.5834V5.83341C5.625 5.25812 6.09137 4.79175 6.66667 4.79175C7.24196 4.79175 7.70833 5.25812 7.70833 5.83341V14.5834C7.70833 15.1587 7.24196 15.6251 6.66667 15.6251C6.09137 15.6251 5.625 15.1587 5.625 14.5834ZM12.2917 14.5834V5.83341C12.2917 5.25812 12.758 4.79175 13.3333 4.79175C13.9086 4.79175 14.375 5.25812 14.375 5.83341V14.5834C14.375 15.1587 13.9086 15.6251 13.3333 15.6251C12.758 15.6251 12.2917 15.1587 12.2917 14.5834Z",
		fill: "url(#paint0_linear_532_243)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_532_243",
		x1: 10.3616,
		y1: 6.51523,
		x2: 10.3616,
		y2: 15.3789,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#80B344" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#5A8D1D"
		})]
	}) })]
});
export default SvgPause;
